import { render, staticRenderFns } from "./AsiLocaleSwitcher.vue?vue&type=template&id=08e21426&scoped=true"
import script from "./AsiLocaleSwitcher.vue?vue&type=script&lang=ts"
export * from "./AsiLocaleSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./AsiLocaleSwitcher.vue?vue&type=style&index=0&id=08e21426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e21426",
  null
  
)

export default component.exports